import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AgamaService from "../../services/AgamaService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataAgama: [],
    dataAgamaByID:[],
    showMessage:false,
    message:''
}


export const getDataAgama = createAsyncThunk('ref/agama',async (data, { rejectWithValue }) => {
    try {
        const response = await AgamaService.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataAgamaByID = createAsyncThunk('ref/pekerjaanbyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await AgamaService.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const agamaSlice = createSlice({
    name: 'agama',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataAgama = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataAgama.fulfilled, (state, action) => {
                state.loading = false
                state.dataAgama = action.payload
            })
            .addCase(getDataAgama.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataAgama.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataAgama = action.payload
            })
            .addCase(getDataAgamaByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataAgamaByID = action.payload
            })
            .addCase(getDataAgamaByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataAgamaByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataAgamaByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = agamaSlice.actions

export default agamaSlice.reducer
